import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private metaService: Meta,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.translate.currentLang = 'fr';
    this.router.events.subscribe((evt) => {
      this.metaService.removeTag('name=description');
      this.metaService.removeTag('name=keywords');

      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, window.pageYOffset - 10000);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts